/// <reference types="vite/client" />
import "./PrivateBeta.css";
import { ButtonLink } from "@ui/ButtonLink";
import { AskConsumerLayout } from "@ui/layouts/AskConsumerLayout/AskConsumerLayout";
import { VStack } from "@ui/Stack";
import { Text } from "@ui/typography/Text";
import { signInUrl } from "~/modules/shared/utils/auth";
import studioPhone from "./studio-phone.png";

export const PrivateBetaApp = () => (
	<AskConsumerLayout
		signedOutTopNav
		showSignUp={false}
		hasHeaderMargin={false}
	>
		<div class="private-beta">
			<div class="private-beta__visual" aria-hidden="true">
				<img src={studioPhone} alt="" class="private-beta__phone" />
			</div>
			<VStack spacing="large" align="start" class="private-beta__copy">
				<Text
					family="mono"
					size="xsmall"
					color="primary"
					transform="uppercase"
					class="private-beta__kicker"
				>
					Private beta
				</Text>
				<h1 class="private-beta__title">AskGVT isn't open yet</h1>
				<Text as="p" size="intermediate" color="fg2">
					If you're part of the beta, log in to continue.
				</Text>
				<ButtonLink href={signInUrl()} variant="primary">
					Log in to continue
				</ButtonLink>
			</VStack>
		</div>
	</AskConsumerLayout>
);
